import { useQuery } from 'react-query';
import { useAuthenticatedAxios } from 'hooks/useAuthenticatedAxios';
import { ErrorResponse, UseQueryFnOptions } from 'types/network';
import { ROUTES } from 'constants/routes';
import { useMswManager } from 'lib/util/useMswManager';
import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';

export const usePartnerGetMaintenanceMode = (
  options?: UseQueryFnOptions<boolean, ErrorResponse>
) => {
  const Axios = useAuthenticatedAxios();

  useMswManager(
    HrznGatewayMswBuilder
      .create()
      .get(ROUTES.PartnerGetMaintenanceMode, {
        data: false
      })
  )

  return useQuery<boolean, ErrorResponse>(
    [ROUTES.PartnerGetMaintenanceMode],
    async () => {
      const { data } = await Axios({
        method: 'get',
        params: {
          route: ROUTES.PartnerGetMaintenanceMode
        }
      });
      return data;
    },
    options
  );
};
